import { connect } from 'react-redux';

import { MapStateToProps } from '~commonInfra/utils/ConnectUtils';
import { siteUrlsSelector } from '~src/bootstrap/redux/selectors/SiteUrlsSelectors';
import { NavLocationSelectors } from '~src/spacesPlatform/selectors/NavigationStateSelectors';

import { AppState } from '../../../bootstrap/redux/state/AppState';
import { PageHeaderMenus, PageHeaderMenusStateProps } from './PageHeaderMenus';


const mapStateToProps: MapStateToProps<PageHeaderMenusStateProps> = (state: AppState): PageHeaderMenusStateProps => ({
  inServerArea: NavLocationSelectors.inServerArea(state),
  inSiteArea: NavLocationSelectors.inSiteArea(state),
  inSiteContentArea: NavLocationSelectors.inSiteContentArea(state),
  siteUrls: siteUrlsSelector(state),
});

export const ConnectedPageHeaderMenus = connect(mapStateToProps)(PageHeaderMenus);
